import type { FileUsage } from '@vedalib/editor/lib/files'
import React from 'react'
import { chainName } from 'utils'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { FieldFile, FieldInput, FormField } from 'components/formKit'
import { t } from 'services/Translation'

import type { DownloaderValueFormType } from './downloaderTypes'

const FILE = genElementValueField({
  as: FieldFile<FileUsage>,
  name: 'file',
  props: {
    fileType: 'document',
    nullable: true,
    preview: true,
    showSource: true,
  },
})

const LABEL = genElementValueField({
  as: FieldInput,
  name: 'label',
  label: t('input.label.name'),
  rules: [{ max: 150 }],
  props: { placeholder: t('input.placeholder.name') },
})

const DownloaderForm: DownloaderValueFormType = ({ name }) => (
  <Padding bottom gap sides>
    <FormField config={chainName(name, FILE)} />
    <FormField config={chainName(name, LABEL)} />
  </Padding>
)

export default DownloaderForm
